import { render, staticRenderFns } from "./InputIntegers.vue?vue&type=template&id=4fba92c0"
import script from "./InputIntegers.vue?vue&type=script&lang=ts"
export * from "./InputIntegers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports